export default "__VITE_ASSET__AwTHyIEr__"